"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.FONT_NAME={BASIS_GROTESQUE_PRO:"Basis Grotesque Pro",PROXIMA_BLACK:"ProximaNovaCond-Black",PROXIMA_EXTRA_BOLD:"ProximaNovaCond-Extrabld",PROXIMA_BOLD:"ProximaNovaCond-Bold"};
//# sourceMappingURL=constants.js.map
